import { Award, FileContent, FileContentFactory, Dependencies } from ".."

export interface ModifyAward {
    isDraft: boolean
    isActive: boolean
    isDeleted: boolean
    names: {
        [key: string]: string
    }
    descriptions: {
        [key: string]: string
    }
    image: FileContent
    amount: number | null
    categoryIds: string[]
    dependencies: Dependencies | null
}

export class ModifyAwardFactory {
    static create(): ModifyAward {
        return {
            isDraft: false,
            isActive: false,
            isDeleted: false,
            names: {},
            descriptions: {},
            image: FileContentFactory.create(),
            amount: null,
            categoryIds: [],
            dependencies: null,
        }
    }

    static from(award: Award): ModifyAward {
        const modifyAward: ModifyAward = JSON.parse(
            JSON.stringify({
                isDraft: award.isDraft,
                isActive: award.isActive,
                isDeleted: award.isDeleted,
                names: award.names,
                descriptions: award.descriptions,
                image: FileContentFactory.fromUrl(award.imageUrl ?? ""),
                amount: award.amount ?? null,
                categoryIds: award.categoryIds ?? [],
                dependencies: award.dependencies ?? null,
            })
        )
        return modifyAward
    }
}
